import * as angular from 'angular';

class TransactionExportHistoryTab {

    constructor(
        public $scope: ng.IScope
    ) {}
}

angular.module('naut').component('transactionExportHistoryTab', {
    template: require('./transaction-export-history.component.html'),
    controller: TransactionExportHistoryTab,
    controllerAs: 'ctrl'
});



// WEBPACK FOOTER //
// ./src/app.retailer/modules/discountForStaff/transaction-tab/transaction-export-history/transaction-export-history.component.ts